"use client";

import { PreviewCard as HoverCardPrimitive } from "@base-ui/react/preview-card";
import * as React from "react";

import { cn } from "@/utils/lib";
import { resolveClassName } from "@/utils/resolve-class-name";

type HoverCardRootProps = Omit<HoverCardPrimitive.Root.Props, "children"> & {
  children?: React.ReactNode;
};

const HoverCard = ({ ...props }: HoverCardRootProps) => (
  <HoverCardPrimitive.Root {...props} />
);

const HoverCardTrigger = ({
  delay = 100,
  ...props
}: React.ComponentProps<typeof HoverCardPrimitive.Trigger>) => (
  <HoverCardPrimitive.Trigger delay={delay} {...props} />
);

const HoverCardContent = ({
  className,
  align = "center",
  alignOffset = 4,
  side = "bottom",
  sideOffset = 4,
  ...props
}: HoverCardPrimitive.Popup.Props &
  Pick<
    HoverCardPrimitive.Positioner.Props,
    "align" | "alignOffset" | "side" | "sideOffset"
  >) => (
  <HoverCardPrimitive.Portal>
    <HoverCardPrimitive.Positioner
      align={align}
      alignOffset={alignOffset}
      side={side}
      sideOffset={sideOffset}
      className="isolate z-100"
    >
      <HoverCardPrimitive.Popup
        className={(state) =>
          cn(
            `
              z-100 w-64
              rounded-md
              border
              bg-popover
              p-4
              text-muted-foreground
              shadow-md
              outline-hidden
              data-ending-style:animate-out
              data-ending-style:fade-out-0
              data-ending-style:zoom-out-95
              data-starting-style:animate-in
              data-starting-style:fade-in-0
              data-starting-style:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=inline-end]:slide-in-from-left-2 data-[side=inline-start]:slide-in-from-right-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2
            `,
            resolveClassName(className, state),
          )
        }
        {...props}
      />
    </HoverCardPrimitive.Positioner>
  </HoverCardPrimitive.Portal>
);
HoverCardContent.displayName = "HoverCardContent";

const HoverCardPortal = HoverCardPrimitive.Portal;

export { HoverCard, HoverCardContent, HoverCardPortal, HoverCardTrigger };
